import ApiService from '@/services/api.service'

const SingleSignOnService = {
    getAll( parameter) { 
      const requestData = {
        method: 'get',
        url: "/SingleSignOns/",
        headers: {
        },
        params: { 
          SearchCriteria: parameter.SearchCriteria,
          PageSize: parameter.PageSize,          
          PageNumber : parameter.PageNumber         
        }
      }     
      return ApiService.customRequest(requestData);         
    },

    getSingleSignOn() {
        return ApiService.get(`/SingleSignOns/`);
      },
  
    get(id) {
      return ApiService.get(`/SingleSignOns/${id}`);
    },

    add(data){
      return ApiService.post(`/SingleSignOns`,data)
    },

    delete(id){
      return ApiService.delete(`/SingleSignOns/${id}`)
    },

    update(id,data){
      return ApiService.put(`/SingleSignOns/${id}`,data)
    },

    existsVendorUserPair(vendorCode,userId){
      return ApiService.get(`/SingleSignOns/ExistsVendorUser/${vendorCode}:${userId}`)
    }
}
  
  export default SingleSignOnService;